import React, { useReducer, useState, useEffect } from 'react';
// import './AddUser.modules.css';
import style from './Register.module.css';
import axios from '../../functions/axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';

function EditUserByAdmin() {
  const { user } = useAuthContext();
  const location = useLocation();
  const formReducer = (state, event) => {
    const form = {
      ...state,
      [event.name]: event.value,
    };
    if (event.value === '') {
      delete form[event.name]
    }
    return form;
  };

  const [formData, setFormData] = useReducer(formReducer, {
    _id: location.state._id,
    userName: location.state.userName,
    surName: location.state.surName,
    email: location.state.email,
    manageUsers: location.state.permissions.manageUsers || false,
    manageCarriage: location.state.permissions.manageCarriage || false,
    managePaletts: location.state.permissions.managePaletts || false,
    manageCarsService: location.state.permissions.manageCarsService || false,
    manageInvoice: location.state.permissions.manageInvoice || false,
  });
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  if (!user) return null;

  const validateData = () => {
    if (formData.password) {
      if (formData.password.length < 8 || formData.password !== formData.passwordConfirm)
        return false;
    }

    return formData.userName && formData.surName && formData.email;
  };

  const handleSubmit = async (event) => {
    if (event.target.id !== 'submit') return;
    event.preventDefault();
    event.stopPropagation();
    setSubmitting(true);
    if (!validateData()) return;
    await axios.patch(`/userAdmin`, formData);
    setTimeout(() => {
      setSubmitting(false);
    }, 3000);
    navigate('/UserList');
  };


  const handleDeleteAppUser = async (event) => {
    if (event.target.id !== 'remove') return;
    event.preventDefault();
    event.stopPropagation();
    const confirmBox = window.confirm('Czy chcesz usunąć tego użytkownika?');
    if (confirmBox) {
      await axios.delete(`/user`, {
        data: {
          _id: location.state._id,
        }
      });
    }
    navigate('/usersList');
  };

  const handleChange = (event) => {
    const isCheckbox = event.target.type === 'checkbox';
    setFormData({
      name: event.target.name,
      value: isCheckbox ? event.target.checked : event.target.value,
    });
  };

  const ConfirmData = () =>
    validateData() ? (
      <div>
        <label>OK! Dane zostały wprowadzone</label>:
        <ul>
          <li>Nazwa użytkownika: {formData.userName}</li>
          <li>Imię i Nazwisko: {formData.surName}</li>
        </ul>
      </div>
    ) : (
      <div>
        <label>Nie poprawne dane</label>
      </div>
    );

  return (
    <div className={style.wrapper}>
      <form onSubmit={handleSubmit}>
        <div className={style.section}>
          <h1>Zmiana hasła użytkownika:</h1>
          <br />
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='password'>
              Stwórz nowe hasło dla użytkownika:
            </label>
            <input
              id='password'
              minLength={8}
              placeholder='podaj hasło'
              name='password'
              type='password'
              onChange={handleChange}
              value={formData.password || ''}
            />
          </div>
          <div className={style.row}>
            <label className={style.subcategory} htmlFor='passwordConfirm'>
              Powtórz hasło:
            </label>
            <input name='passwordConfirm' placeholder='potwierdź hasło' type='password' onChange={handleChange} value={formData.passwordConfirm || ''} />
          </div>
        </div>
        <hr />
        <div className={style.buttons}>
          <button className='btn btn-default' onClick={navigate.bind(null, '../userList', { state: { date: formData.day } })}>
            Anuluj
          </button>
          <button className='btn btn-danger' onClick={handleDeleteAppUser}>
            Usuń Użytkownika
          </button>
          <button className='btn btn-default' type='submit'>
            Zaktualizuj użytkownika
          </button>
        </div>
      </form>

      {submitting && <ConfirmData />}
    </div>
  );
}

export default EditUserByAdmin;
